import React from 'react'
import WOW from 'react-wow'
import {Col} from '@bootstrap-styled/v4'

import BlogItem from 'src/components/ui/BlogItem'

const Hit = ({hit}) => {
    return (
        <WOW animation="fadeIn" key={hit.slug}>
            <Col xs={12} sm={6} lg={4} style={{display: 'flex', alignItems: 'stretch', marginBottom: '25px'}}>
                <BlogItem
                    slug={hit.fields.slug}
                    title={hit.title}
                    description={hit.description}
                    img={hit.image}/>
            </Col>
        </WOW>
    )
}

export default Hit